// Super Admins and Store owners can use everything their role reaches. A Sub Admin gets only the areas the Super
// Admin switched on for them, and Staff only the areas their store owner ticked
// ('content', 'orders', 'customers', 'settings').
// Support Admins only edit websites (the backend's middleware/roles.js limitSupport refuses the rest).
export const can = (user, permission) => (user.role === "support" ? permission === "content" : !["subadmin", "staff"].includes(user.role) || (user.permissions || []).includes(permission));
